import { render, staticRenderFns } from "./ClickableList.vue?vue&type=template&id=4480fae8&scoped=true&"
import script from "./ClickableList.vue?vue&type=script&lang=js&"
export * from "./ClickableList.vue?vue&type=script&lang=js&"
import style0 from "./ClickableList.vue?vue&type=style&index=0&id=4480fae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4480fae8",
  null
  
)

export default component.exports